import { type FC } from 'preact/compat';

import { Preloader } from '@/entities/preloader/ui';

interface Props {
  pdOpen: boolean;
}

export const HideUILoadingScreen: FC<Props> = ({ pdOpen }) => {
  return <Preloader pdOpen={pdOpen} showProgress />;
};
